<template>
  <div>
    <v-flex xs12 class="text-center text-sm-center text-md-center text-lg-center">
      <v-img :src="imageUrl" height="150" v-if="imageUrl && preview" />
      <template v-if="required">
        <v-text-field
          :label="label"
          @click="pickFile"
          v-model="imageName"
          prepend-inner-icon="attach_file"
          readonly
          v-validate="'required'"
          data-vv-name="file"
          :error-messages="errors.collect('file')"
          :class="className"
        >
        </v-text-field>
      </template>
      <template v-else>
        <v-text-field :label="label" @click="pickFile" v-model="imageName" prepend-inner-icon="attach_file" readonly>
        </v-text-field>
      </template>
      <input type="file" style="display: none" ref="image" :accept="accept" @change="onFilePicked" />
    </v-flex>
  </div>
</template>

<script>
import formMixins from '../Mixins/form';

export default {
  mixins: [formMixins],
  inject: ['parentValidator'],
  props: {
    value: File,
    label: String,
    accept: {
      type: String,
      default: 'image/*',
    },
    preview: {
      type: Boolean,
      default: false,
    },
    selectedCallback: Function,
    title: {
      type: String,
      default: 'Image Upload',
    },
    required: Boolean,
    className: String,
    scopeForm: '',
  },
  data: () => ({
    dialog: false,
    imageName: '',
    imageUrl: '',
    imageFile: '',
  }),
  watch: {
    value(val) {
      if (!val) this.reset();
    },
  },
  computed: {
    // imgName() {
    //   return this.imageName
    // }
  },
  methods: {
    update(e) {
      this.$emit('input', e.target.files[0]);
    },
    pickFile() {
      this.$refs.image.click();
    },
    reset() {
      console.log('reset upload');
      this.imageName = '';
      this.imageFile = '';
      this.imageUrl = '';
      this.$emit('input', null);
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files && files[0]) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf('.') <= 0) {
          return;
        }
        this.$nextTick(() => {
          this.$validator.validateAll();
        });

        const reader = new FileReader();
        const vm = this;

        reader.onload = function onload(e) {
          vm.imageUrl = e.target.result;
        };
        reader.readAsDataURL(files[0]);

        this.imageFile = files[0];

        this.$emit('input', this.imageFile);

        if (this.selectedCallback) {
          if (e.target.files[0]) {
            this.selectedCallback({
              imageUrl: this.imageUrl,
              imageFile: this.imageFile,
              imageName: this.imageName,
            });
          } else {
            this.selectedCallback(null);
          }
        }
      } else {
        this.reset();
      }
    },
  },
  mounted() {
    // if (!this.required) {
    //   // disable vee-validate
    //   this.$validator.pause()
    // }
  },
  created() {
    this.$validator = this.parentValidator;
  },
};
</script>
